import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const VehicleRegNo = (props) => {
  return (
    <FormGroup controlId="vehicleRegNo">
      <Col componentClass={ControlLabel} sm={4}>
        Vehicle Reg No.
      </Col>
    <Col sm={8}>
        <FormControl type="text" value={props.vehicleRegNo}
          onChange={props.handleChangeVehicleRegNo} autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

VehicleRegNo.propTypes = {
  vehicleRegNo: PropTypes.string,
  handleChangeVehicleRegNo: PropTypes.func
};

export default VehicleRegNo;



// WEBPACK FOOTER //
// ./src/app/components/retrieveQuotationComponent/vehicleRegNo/VehicleRegNo.js